$(document).ready(function() {
    console.log('Blogs Category')
  
  
    $(document).on('click', '.paginate a', function(e) {
        e.preventDefault();
    
        let newUrl = $(this).attr('href');
        filter(newUrl);
    
        $('html, body').animate({
            scrollTop: $('.main-blog-section').offset().top - 100
        }, 0);
    });


  
      if ($('.blog-category-featured-articles-section').length) {
          console.log('here')
          // Toggle dropdown visibility
          $('.dropdown-selected').on('click', function () {
            $(this).next('.dropdown-options').toggle();
          });
        
          // Handle option click
          $('.dropdown-option').on('click', function () {
            var selectedText = $(this).text();
            var selectedUrl = $(this).data('url');
        
            // Update visible selected text
            $(this).closest('.custom-dropdown').find('.dropdown-selected').text(selectedText);
        
            // Hide options
            $('.dropdown-options').hide();
        
            // Redirect to selected URL
            if (selectedUrl) {
              window.location.href = selectedUrl;
            }
          });
        
          // Close dropdown when clicking outside
          $(document).on('click', function (e) {
            if (!$(e.target).closest('.custom-dropdown').length) {
              $('.dropdown-options').hide();
            }
          });
      }
});


function filter(newUrl) {

    $.ajax({
        type: "GET",
        url: newUrl,
        success: function(data) {

            //desktop update product list
            if ($(data).find('.main-blog-list').find('.default-blog-item').length > 0) {
                $('.main-blog-list').html($(data).find('.main-blog-list').html());
              
            }
            //show hide pagination
            if ($('.paginate').find('.page:not(.disable)').length > 0)
                $('.paginate').css('display', 'flex');
            else
                $('.paginate').css('display', 'none');


        },
        error: function() {
            console.log("Error occurred while filtering products.");
            $('.main-blog-list').empty();
        },
    });

    if (window.history && window.history.pushState) {
        window.history.pushState(null, null, newUrl);
    }
}

$(window).on('scroll', function() {
  
});